export default __webpack_public_path__ + "static/media/3131.1bc56349.jpg";